module.exports = __webpack_public_path__ + "img/mission-image-1.e9a64298.jpg";